<template lang="pug">
  .content-cartel-base
    .sky
    .airplane
    .palm-left
    .sand
    .bag
    .boy
    .palm-right
    .base-curve
    .ccm-logo
    .renoved-text
    .contain-logos
      img.main-title-logo(src="/images/logo-01.svg")
      img.small-title-logo(src="/images/aviso-tabla-01.png")
</template>

<script>

import { TweenMax, TimelineMax } from 'gsap'
import SVGDrawPlugin from '../../svgDraw'

export default {
  data(){
    return {
      context: new AudioContext(),
      url: '/sound/playa.mp3',
      playing: false
    }
  },
  methods:{
    play(audioBuffer){
      if(this.playing || audioBuffer == null){
        return
      }
      this.playing = true
      const source = this.context.createBufferSource();
      source.buffer = audioBuffer;
      source.loop = true;
      const gainNode = this.context.createGain();
      gainNode.gain.value = 0.1;
      gainNode.connect(this.context.destination);
      source.connect(gainNode);
      source.start();
    }
  },
  mounted() {
    let vm = this
      
    let yodelBuffer = null;

    window.fetch(vm.url)
      .then(response => response.arrayBuffer())
      .then(arrayBuffer => vm.context.decodeAudioData(arrayBuffer))
      .then(audioBuffer => {
        yodelBuffer = audioBuffer;
      });
      window.document.onclick = () => vm.play(yodelBuffer);
    /*
    const { pl, sl, tl } = this.$refs
    const l = document.getElementsByClassName('logo-ccm')[0]
    TweenMax.to(pl, 0, {
      drawSVG: "0%",
      delay: 0
    })
    TweenMax.to(sl, 0, {
      drawSVG: "0%",
      delay: 0
    })
    TweenMax.to(tl, 0, {
      drawSVG: "0%",
      delay: 0
    })
    TweenMax.to(pl, 3, {
      drawSVG: true,
      delay: 1
    })
    TweenMax.to(tl, 3, {
      drawSVG: true,
      delay: 2
    })
    TweenMax.to(sl, 3, {
      drawSVG: true,
      delay: 3
    })
    TweenMax.to(pl, 1, {
      fill: '#fff',
      delay: 4
    })
    TweenMax.to(tl, 1, {
      fill: '#fff',
      delay: 5
    })
    TweenMax.to(sl, 1, {
      fill: '#fff',
      delay: 6
    })
    */
  }
}
</script>

<style lang="sass">
  .content-cartel-base
    height: 85vh
    position: relative
  .sky
    height: 85vh
    width: calc( 100% + 20px)
    background: url(../../../images/assets2020/fondo-01.jpg) no-repeat center
    animation: movesea 5s infinite alternate
    background-size: cover
  .palm-left,.palm-right
    position: absolute
    width: 35%
    height: 410px
    top: 0px
    background: url(../../../images/assets2020/palmera-01.png) no-repeat
    background-size: contain
    background-position: top right
  .airplane
    position: absolute
    width: 170px
    height: 160px
    top: 30vh
    background: url(../../../images/assets2020/airplane.png) no-repeat
    background-size: contain
    background-position: center
    animation: flyAirplane 20s infinite linear
  .palm-right
    right: -2%
    animation: movepalms 5s infinite alternate
    transform-origin: top right
  .palm-left
    left: -37%
    transform: rotateY(180deg)
    transform-origin: top right
    animation: movepalmsL 5s infinite alternate-reverse
  .base-curve
    position: absolute
    width: 100%
    height: 22vw
    bottom: 0px
    background: url(../../../images/assets2020/curvas-01.svg) no-repeat
    background-size: cover
    background-position: center top
  .sand
    position: absolute
    width: 100%
    height: 22vh
    top: 59vh
    background: url(../../../images/assets2020/arena-01.png) no-repeat
    background-size: cover
    background-position: center top
  .boy
    position: absolute
    width: 250px
    height: 63vh
    bottom: 90px
    right: 21%
    background: url(../../../images/assets2020/chico-01.png) no-repeat
    background-size: contain
    background-position: center bottom
  .bag
    position: absolute
    width: 186px
    height: 44vh
    bottom: 114px
    right: 38%
    background: url(../../../images/assets2020/maleta-01.png) no-repeat
    background-size: contain
    background-position: center bottom
    animation: moveBag 10s infinite alternate
  .contain-logos
    position: absolute
    top: 15%
    left: 15%
    transition: .5s ease-in-out
    &:hover
      transform: scale(1.2)
  .small-title-logo
    position: relative
    display: block
    width: 35%
    height: auto
    z-index: 1
    top: -7vw
    max-width: 1100px
    animation: moveTable 5s infinite alternate
  .main-title-logo
    position: relative
    display: block
    width: 45%
    height: auto
    z-index: 2
    max-width: 1100px
  .renoved-text
    position: absolute
    width: 33%
    height: 120px
    bottom: 3vw
    left: 0
    filter: drop-shadow(2px 4px 20px rgba(0,0,0,.5))
    background: url(../../../images/assets2020/renovar-crecer-01.svg) no-repeat
    background-size: contain
    background-position: center left
  .ccm-logo
    position: absolute
    width: 15%
    height: 120px
    bottom: 3vw
    right: 3vw
    background: url(../../../images/assets2020/badge.svg) no-repeat
    background-size: contain
    background-position: center right

</style>



// WEBPACK FOOTER //
// resources/js/components/PageConcurso2020/BeachImage.vue